import { Button, Form } from "react-bootstrap";
import BadgeEstados from "../../../../components/BadgeEstado";
import ExcelButton from "../../../../components/ExcelButton";
import { useGeneralAppStore } from "../../../../store/generalAppStore";

const HeaderActas = ({
    estados,
    actas,
    actasFilter,
    filterFields,
    actasLocale,
    activeImprimir,
    setActiveImprimir,
    activeAsignar,
    setActiveAsignar,

    actasAImprimir, setActasAImprimir,
    notificador, setNotificador,
    actasAsignar, setActasAsignar,
}) => {

    const { handlerModal, loads } = useGeneralAppStore();

    const loadKeys = [
        "asignar_notificador",
        "acta_detalle",
        "desasignar_notificador",
        "marcar_impresa",
        "notificadores",
    ];

    const headers = [
        { label: "ID", key: "id" },
        { label: "Fecha hora", key: "fecha_hora" },
        { label: "#Acta", key: "numero_acta" },
        { label: "Fecha notificación", key: "fecha_notificacion" },
        { label: "Infraccion", key: "tipo" },
        { label: "Patente", key: "plate" },
        { label: "Localidad", key: "localidad" },
        { label: "Documento", key: "documento_titular" },
    ];

    return (

        <div className="d-flex justify-content-between align-items-center" style={{ minHeight: "80px" }} >
            <div className="d-flex align-items-center gap-5" >
                <div className="d-flex align-items-center gap-2">
                    <span className="fw-bold text-primary">{estados.length > 1 ? "Estados" : "Estado"}:</span>
                    <div className="d-flex gap-3 ">
                        {
                            estados.map((estado, index) => (
                                <BadgeEstados key={index} estado_id={estado} size={"xsm"} />
                            ))
                        }

                    </div>
                </div>
                {
                    estados.includes(10) &&
                    <>
                        <Button variant={`${activeImprimir ? 'primary' : 'secondary'}`} size="sm" onClick={() => { setActiveImprimir(!activeImprimir) }} >Imprimir actas</Button>
                        {
                            activeImprimir &&
                            <Form.Group className="d-flex flex-column align-items-center">
                                <Button
                                    onClick={() => handlerModal({ modal: true, modalName: "modal_imprimir_actas" })}
                                    disabled={actasAImprimir.length == 0 || loadKeys.some(key => loads.includes(key))} style={{ minWidth: "83px" }}>
                                    <span className="m-0 fw-light">{actasAImprimir.length} Actas para imprimir</span>
                                </Button>
                            </Form.Group>
                        }

                    </>
                }
                {
                    estados.includes(2) &&
                    <>
                        <Button variant={`${activeAsignar ? 'warning' : 'secondary'}`} size="sm" onClick={() => { setActiveAsignar(!activeAsignar) }} >Asignar actas</Button>
                        {
                            activeAsignar &&
                            (
                                <div className="d-flex align-items-center gap-4">
                                    <Form.Group className="d-flex flex-column align-items-center ">
                                        <Form.Label className="m-0 w-100 text-center" style={{ fontSize: "0.8rem" }}>
                                            Notificador
                                        </Form.Label>
                                        <Button
                                            onClick={() => handlerModal({ modal: true, modalName: "notificadores_table" })}
                                            disabled={(actasAImprimir.length != 0)} style={{ minWidth: "83px" }}><span className="m-0 fw-light">{notificador?.nombre || "Seleccione notificador"}</span></Button>
                                    </Form.Group>
                                    {notificador?.nombre &&
                                        <Form.Group className="d-flex flex-column align-items-center ">
                                            <Form.Label className="m-0 w-100 text-center" style={{ fontSize: "0.8rem" }}>
                                                Asginar
                                            </Form.Label>
                                            <Button
                                                onClick={() => { handlerModal({ modal: true, modalName: "modal_asignar_actas" }) }}
                                                disabled={(actasAsignar.length == 0)} style={{ minWidth: "83px" }}><span className="m-0 fw-light">{actasAsignar?.length} Actas</span></Button>
                                        </Form.Group>
                                    }
                                </div>
                            )
                        }
                    </>
                }

            </div>
            <div className=" d-flex  align-items-center gap-4 " style={{ width: "fit-content" }}>
                <div className="d-flex align-items-center " >
                    <ExcelButton headers={headers} filename={"listado-actas.csv"} estados={estados} filterFields={filterFields} actasLocale={actasLocale} />
                </div>
            </div>
        </div>

    );
}
export default HeaderActas;